import * as React from 'react';

import * as styles from './styles.css';

export interface IMarketPriceProps {
  price: string;
  subtitle: string;
}

export const MarketPrice: React.FC<IMarketPriceProps> = ({ price, subtitle }) => {
  return (
    <>
      <div className={styles['price']}>{price}</div>
      <div className={styles['subtext']}>{subtitle}</div>
    </>
  );
};

MarketPrice.displayName = 'MarketPrice';
